import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'signaturit-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DatepickerComponent implements OnInit {
  @Input() label: string;

  @Input() placeholder: string;

  @Input() value: string;

  @Input() required: boolean;

  @Input() nameForm: string;

  @Input() range: boolean;

  @Input() range1: string;

  @Input() range2: string;

  @Input() events: Observable<void>;

  @Output() valueChange: EventEmitter<Date> = new EventEmitter<Date>();

  @Output() valueChangeTemplate: EventEmitter<{ key: string, value: string }> = new EventEmitter<{ key: string, value: string }>();

  @Output() valueRangeChangeTemplate: EventEmitter<{ startDate: string, endDate: string }> = new EventEmitter<{ startDate: string, endDate: string }>();

  public eventsSubscription: Subscription;

  showError: boolean = false;

  showErrorRange: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.eventsSubscription = this.events?.subscribe(() => this.clearInputDate());
  }

  inputChange(event): void {
    const date = new Date(this.value);
    this.valueChange.emit(date);
    const convertedDate = this.transformDate(date);
    const value = !this.value ? '' : convertedDate;
    this.valueChangeTemplate.emit({ key: this.nameForm, value });
    this.onBlur(event);
  }

  dateRangeChange(event, dateRangeStart: string, dateRangeEnd: string): void {
    if (dateRangeEnd) {
      const startDate = new Date(dateRangeStart);
      const valueRange1 = this.transformDate(startDate);
      const endDate = new Date(dateRangeEnd);
      const valueRange2 = this.transformDate(endDate);
      this.valueRangeChangeTemplate.emit({ startDate: valueRange1, endDate: valueRange2 });
      this.onBlurRange(event);
    }
  }

  transformDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  clearInputDate(): void {
    this.range1 = '';
    this.range2 = '';
  }

  onBlur(event): void {
    this.showError = !event.value && event.required ? true : false;
  }

  onBlurRange(event): void {
    this.showErrorRange = !event.range1 && !event.range2 && event.required ? true : false;
  }
}
